import {Component, Directive, Input} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatButton} from '@angular/material/button';
import {MatDialogTitle} from '@angular/material/dialog';
import {NgTemplateOutlet} from '@angular/common';
import {A11yModule} from '@angular/cdk/a11y';

@Component({
  imports: [MatCardModule, MatDialogTitle, NgTemplateOutlet],
  selector: 'app-dialog',
  templateUrl: './app-dialog.component.html',
  styleUrls: ['./app-dialog.component.scss'],
})
export class AppDialogComponent {
  @Input() showInnerCard: boolean = true;
}

@Directive({
  selector: 'app-dialog-title, [appDialogTitle], [app-dialog-title]',
})
export class AppDialogTitleDirective {}

@Directive({
  selector: 'app-dialog-subtitle, [appDialogSubtitle], [app-dialog-subtitle]',
})
export class AppDialogSubtitleDirective {}

@Component({
  selector: 'app-dialog-action-button, [appDialogActionButton], [app-dialog-action-button]',
  imports: [MatButton, A11yModule, NgTemplateOutlet],
  template: ` <ng-template #contentTpl>
      <ng-content></ng-content>
    </ng-template>
    @if (primary) {
      <button type="button" matButton cdkFocusInitial [disabled]="disabled">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </button>
    } @else {
      <button type="button" matButton [disabled]="disabled">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
      </button>
    }`,
})
export class AppDialogActionButtonComponent {
  @Input() primary: boolean = false;
  @Input() disabled: boolean = false;
}

@Directive({
  selector: 'app-dialog-header-button, [appDialogHeaderButton], [app-dialog-header-button]',
})
export class AppDialogHeaderButtonDirective {}

@Directive({
  selector:
    'app-dialog-action-button-custom, [appDialogActionButtonCustom], [app-dialog-action-button-custom]',
})
export class AppDialogActionButtonCustomDirective {}
